import store from './index';
import { getState } from './storage';

export default function () {
  //console.log("STORE INITIALIZED: ",store.state.initialized);
  if (store.state.initialized == true) {
    return Promise.resolve();
  }
  return getState().then(state => store.commit('loadFromCache', state));
}